"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_VIDEO_HAS_CONTROLS = exports.DATA_MEDIA_SCALE = exports.DATA_HIGHLIGHT = exports.DATA_SEARCH_TOGGLER = exports.DATA_HEADER_SEARCHBOX_INPUT = exports.DATA_HEADER_SEARCHBOX = exports.DATA_SOLR_SUGGESTION_CONTAINER = exports.DATA_SOLR_SEARCH_HEADLINE = exports.DATA_SOLR_INPUT_SUGGEST = exports.DATA_SOLR_FORM = exports.NAME_SOLR_SUGGEST_FORM_AJAX_PARAMETER = exports.DATA_INPAGE_TARGETS = exports.DATA_INPAGE_LINK = exports.DATA_INPAGE_NAV = exports.DATA_TABELEMENT_ACC_HEADER = exports.DATA_TABELEMENT_ACC = exports.DATA_TABELEMENT = exports.DATA_CHIP_LIST_TOGGLER = exports.DATA_CHIP_LIST = exports.DATA_CHIP_WRAP = exports.DATA_LANGUAGE_TRIGGER = exports.DATA_FILEUPLOAD_CHOSEN_FILE = exports.DATA_FILEUPLOAD_INPUT = exports.DATA_FILEUPLOAD_WRAP = exports.DATA_FORM_FIELD_ERROR_TEXT = exports.DATA_FORM_FIELD_ERROR = exports.DATA_FORM_FIELD = exports.DATA_FORM_FIELD_WRAP = exports.DATA_FORM_SUBMIT_ICON = exports.DATA_FORM_SUBMIT_TEXT = exports.DATA_FORM_SUBMIT = exports.DATA_FORM = exports.DATA_KEYFIGURES_END = exports.DATA_KEYFIGURES_NUMBER = exports.DATA_KEYFIGURES = exports.DATA_SUBMENU_LVL_2 = exports.DATA_TOGGLE_SUBMENU_LVL_2 = exports.DATA_SUBMENU = exports.DATA_TOGGLE_SUBMENU = exports.DATA_NAV_LINK_LVL_2 = exports.DATA_NAV_LINK = exports.DATA_NAVBAR_COLLAPSE = exports.DATA_NAVBAR_TOGGLE = exports.DATA_NAVBAR = exports.DATA_STICKY_HEADER = exports.DATA_ACCORDION_ITEM_HEADER = exports.DATA_ACCORDION = exports.DATA_VIDEO_SLIDER = exports.DATA_INTERVIEW_SLIDER = exports.DATA_SLIDER = void 0;
exports.DATA_BENEFIT_TITLE = exports.DATA_BENEFITS = exports.DATA_FILTER_SELECT = exports.DATA_QUIZ_CHANGE_STEP = exports.DATA_QUIZ_VALIDATE_BTN = exports.DATA_QUIZ_INPUT = exports.DATA_QUIZ_STEP = exports.DATA_QUIZ_RESTART_BTN = exports.DATA_QUIZ_NEXT_BTN = exports.DATA_QUIZ_STEP_FORM = exports.DATA_QUIZ_ELEMENT = exports.DATA_IFRAME_SRC = exports.DATA_MODAL = exports.DATA_CLICK_TARGET = exports.DATA_TRACK_MAP_PIN = exports.DATA_TRACK_ENCRYPTED_EMAIL = exports.DATA_TRACK_DOWNLOAD = exports.DATA_CONTACT_CHOOSER_TARGET = exports.DATA_CONTACT_CHOOSER_TRIGGER = exports.DATA_CONTACT_CHOOSER = exports.DATA_SIMPLEBAR = exports.DATA_VIDEO_AUTOPLAY = void 0;
// Splide SLider
exports.DATA_SLIDER = 'data-slider';
exports.DATA_INTERVIEW_SLIDER = 'data-interview-slider';
exports.DATA_VIDEO_SLIDER = 'data-video-slider';
// Accordion
exports.DATA_ACCORDION = 'data-accordion';
exports.DATA_ACCORDION_ITEM_HEADER = 'data-accordion-item-header';
// Sticky Header
exports.DATA_STICKY_HEADER = 'data-sticky-header';
// Menu Navigation
exports.DATA_NAVBAR = 'data-navbar';
exports.DATA_NAVBAR_TOGGLE = 'data-navbar-toggle';
exports.DATA_NAVBAR_COLLAPSE = 'data-navbar-collapse';
exports.DATA_NAV_LINK = 'data-nav-link';
exports.DATA_NAV_LINK_LVL_2 = 'data-nav-link-lvl-2';
exports.DATA_TOGGLE_SUBMENU = 'data-toggle-submenu';
exports.DATA_SUBMENU = 'data-submenu';
exports.DATA_TOGGLE_SUBMENU_LVL_2 = 'data-toggle-submenu-lvl-2';
exports.DATA_SUBMENU_LVL_2 = 'data-submenu-lvl-2';
// Keyfigures
exports.DATA_KEYFIGURES = 'data-keyfigures';
exports.DATA_KEYFIGURES_NUMBER = 'data-keyfigures-number';
exports.DATA_KEYFIGURES_END = 'data-keyfigures-end';
// Forms
exports.DATA_FORM = 'data-form';
exports.DATA_FORM_SUBMIT = 'data-form-submit';
exports.DATA_FORM_SUBMIT_TEXT = 'data-form-submit-text';
exports.DATA_FORM_SUBMIT_ICON = 'data-form-submit-icon';
exports.DATA_FORM_FIELD_WRAP = 'data-form-field-wrap';
exports.DATA_FORM_FIELD = 'data-form-field';
exports.DATA_FORM_FIELD_ERROR = 'data-form-field-error';
exports.DATA_FORM_FIELD_ERROR_TEXT = 'data-form-field-error-text';
exports.DATA_FILEUPLOAD_WRAP = 'data-fileupload-wrap';
exports.DATA_FILEUPLOAD_INPUT = 'data-fileupload-input';
exports.DATA_FILEUPLOAD_CHOSEN_FILE = 'data-fileupload-chosen-file';
// Language Switch Trigger
exports.DATA_LANGUAGE_TRIGGER = 'data-language-trigger';
// Chip list expandable
exports.DATA_CHIP_WRAP = 'data-chip-wrap';
exports.DATA_CHIP_LIST = 'data-chip-list';
exports.DATA_CHIP_LIST_TOGGLER = 'data-chip-list-toggler';
// Tabelement
exports.DATA_TABELEMENT = 'data-tabelement';
exports.DATA_TABELEMENT_ACC = 'data-tabelement-acc';
exports.DATA_TABELEMENT_ACC_HEADER = 'data-tabelement-acc-header';
// Inpage Nav
exports.DATA_INPAGE_NAV = 'data-inpage-nav';
exports.DATA_INPAGE_LINK = 'data-inpage-nav-link';
exports.DATA_INPAGE_TARGETS = 'data-inpage-targets';
// SOLR
exports.NAME_SOLR_SUGGEST_FORM_AJAX_PARAMETER = 'tx_solr[queryString]';
exports.DATA_SOLR_FORM = 'data-solr-form';
exports.DATA_SOLR_INPUT_SUGGEST = 'data-solr-input-suggest';
exports.DATA_SOLR_SEARCH_HEADLINE = 'data-solr-search-headline';
exports.DATA_SOLR_SUGGESTION_CONTAINER = 'data-solr-suggestion-container';
exports.DATA_HEADER_SEARCHBOX = 'data-header-searchbox';
exports.DATA_HEADER_SEARCHBOX_INPUT = 'data-header-searchbox-input';
exports.DATA_SEARCH_TOGGLER = 'data-search-toggler';
// Scale Media On Scroll
exports.DATA_HIGHLIGHT = 'data-highlight';
exports.DATA_MEDIA_SCALE = 'data-media-scale';
// Videos
exports.DATA_VIDEO_HAS_CONTROLS = 'data-video-has-controls';
exports.DATA_VIDEO_AUTOPLAY = 'data-video-autoplay';
exports.DATA_SIMPLEBAR = 'data-simplebar';
// Contact Chooser
exports.DATA_CONTACT_CHOOSER = 'data-contact-chooser';
exports.DATA_CONTACT_CHOOSER_TRIGGER = 'data-contact-result-button';
exports.DATA_CONTACT_CHOOSER_TARGET = 'data-contact-result';
// Tracking
exports.DATA_TRACK_DOWNLOAD = 'data-track-download';
exports.DATA_TRACK_ENCRYPTED_EMAIL = 'data-mailto-token';
exports.DATA_TRACK_MAP_PIN = 'data-track-map-pin';
// Click on page load
exports.DATA_CLICK_TARGET = 'data-click-target';
// Modal
exports.DATA_MODAL = 'data-modal';
// iFrame
exports.DATA_IFRAME_SRC = 'data-iframe-src';
// Quiz
exports.DATA_QUIZ_ELEMENT = 'data-quiz-element';
exports.DATA_QUIZ_STEP_FORM = 'data-quiz-step-form';
exports.DATA_QUIZ_NEXT_BTN = 'data-quiz-next-btn';
exports.DATA_QUIZ_RESTART_BTN = 'data-quiz-restart-btn';
exports.DATA_QUIZ_STEP = 'data-quiz-step';
exports.DATA_QUIZ_INPUT = 'data-quiz-input';
exports.DATA_QUIZ_VALIDATE_BTN = 'data-quiz-validate-btn';
exports.DATA_QUIZ_CHANGE_STEP = 'data-quiz-change-step';
exports.DATA_FILTER_SELECT = 'data-filter-select';
// Benefits
exports.DATA_BENEFITS = 'data-benefits';
exports.DATA_BENEFIT_TITLE = 'data-benefit-title';
